// Getters
export const STATUS = 'customer_chat/STATUS'
export const CONNECTION_STATUS = 'customer_chat/CONNECTION_STATUS'
export const ACTIVE_SCOPE = 'customer_chat/ACTIVE_SCOPE'
export const INBOX = 'customer_chat/INBOX'
export const INBOX_ITEMS = 'customer_chat/INBOX_ITEMS'
export const OPEN_CONVERSATION = 'customer_chat/OPEN_CONVERSATION'
export const OPEN_MESSAGES = 'customer_chat/OPEN_MESSAGES'
export const OPEN_MESSAGES_STATE = 'customer_chat/OPEN_MESSAGES_STATE'
export const OPEN_TYPING = 'customer_chat/OPEN_TYPING'
export const MY_PRINCIPAL = 'customer_chat/MY_PRINCIPAL'
export const TOTAL_UNREAD = 'customer_chat/TOTAL_UNREAD'
export const TOTAL_UNREAD_BADGE = 'customer_chat/TOTAL_UNREAD_BADGE'

// Mutations
export const MUTATE_STATUS = 'customer_chat/MUTATE_STATUS'
export const MUTATE_CONNECTION_STATUS = 'customer_chat/MUTATE_CONNECTION_STATUS'
export const MUTATE_ACTIVE_SCOPE = 'customer_chat/MUTATE_ACTIVE_SCOPE'
export const MUTATE_INBOX_LOADING = 'customer_chat/MUTATE_INBOX_LOADING'
export const MUTATE_INBOX_PAGE = 'customer_chat/MUTATE_INBOX_PAGE'
export const MUTATE_UPSERT_CONVERSATIONS = 'customer_chat/MUTATE_UPSERT_CONVERSATIONS'
export const MUTATE_MOVE_CONVERSATION_TO_TOP = 'customer_chat/MUTATE_MOVE_CONVERSATION_TO_TOP'
export const MUTATE_OPEN_CONVERSATION_ID = 'customer_chat/MUTATE_OPEN_CONVERSATION_ID'
export const MUTATE_VIEW_VISIBLE = 'customer_chat/MUTATE_VIEW_VISIBLE'
export const MUTATE_MERGE_MESSAGES = 'customer_chat/MUTATE_MERGE_MESSAGES'
export const MUTATE_MESSAGES_STATE = 'customer_chat/MUTATE_MESSAGES_STATE'
export const MUTATE_MESSAGE_LOCAL_STATUS = 'customer_chat/MUTATE_MESSAGE_LOCAL_STATUS'
export const MUTATE_REMOVE_PENDING_MESSAGE = 'customer_chat/MUTATE_REMOVE_PENDING_MESSAGE'
export const MUTATE_CUSTOMER_READ = 'customer_chat/MUTATE_CUSTOMER_READ'
export const MUTATE_MY_READ = 'customer_chat/MUTATE_MY_READ'
export const MUTATE_TYPING = 'customer_chat/MUTATE_TYPING'
export const MUTATE_REMOVE_FROM_INBOXES = 'customer_chat/MUTATE_REMOVE_FROM_INBOXES'
export const MUTATE_RESET = 'customer_chat/MUTATE_RESET'

// Actions
export const INIT = 'customer_chat/INIT'
export const RESET = 'customer_chat/RESET'
export const SET_ACTIVE_SCOPE = 'customer_chat/SET_ACTIVE_SCOPE'
export const FETCH_INBOX = 'customer_chat/FETCH_INBOX'
export const REFRESH_INBOXES = 'customer_chat/REFRESH_INBOXES'
export const OPEN_CONVERSATION_BY_ID = 'customer_chat/OPEN_CONVERSATION_BY_ID'
export const CLOSE_CONVERSATION = 'customer_chat/CLOSE_CONVERSATION'
export const OPEN_CONVERSATION_BY_CUSTOMER = 'customer_chat/OPEN_CONVERSATION_BY_CUSTOMER'
export const LOAD_OLDER_MESSAGES = 'customer_chat/LOAD_OLDER_MESSAGES'
export const CATCH_UP = 'customer_chat/CATCH_UP'
export const SEND_MESSAGE = 'customer_chat/SEND_MESSAGE'
export const RETRY_MESSAGE = 'customer_chat/RETRY_MESSAGE'
export const DISCARD_MESSAGE = 'customer_chat/DISCARD_MESSAGE'
export const MARK_OPEN_AS_READ = 'customer_chat/MARK_OPEN_AS_READ'
export const SET_VIEW_VISIBLE = 'customer_chat/SET_VIEW_VISIBLE'
export const SEND_TYPING = 'customer_chat/SEND_TYPING'
export const HANDLE_FRAME = 'customer_chat/HANDLE_FRAME'
export const FETCH_INVITABLE_USERS = 'customer_chat/FETCH_INVITABLE_USERS'
export const FETCH_DEPARTMENTS = 'customer_chat/FETCH_DEPARTMENTS'
export const INVITE_PARTICIPANT = 'customer_chat/INVITE_PARTICIPANT'
export const REMOVE_PARTICIPANT = 'customer_chat/REMOVE_PARTICIPANT'
